import React, { useRef, useState } from "react";
import { db } from "../db/firestore";
import { QRCodeSVG } from "qrcode.react";
import { shopchamAPI } from "../Utility/api";
import { useDispatch } from "react-redux";
import { signin_customToken } from "../redux/authSlice";
import { Button } from "react-bootstrap";

function LoginByScan() {
    const [docId, setDocId] = useState(false);
  const dispatch = useDispatch();
  const unsubscribeRef = useRef(null);

  const startListener = async (docId) => {
    console.log("Starting Firestore listener...");

    unsubscribeRef.current = db.collection("loginByScan")
      .where('docId','==',docId)
    //   .doc(docId)
      .onSnapshot(
        { includeQueryMetadataChanges: true },
        async (snapshot) => {
          snapshot.docChanges().forEach( async (change) => {
            console.log(change?.doc?.data())
            if (change.type === "modified") {
              const { uid } = change.doc.data();
              if (uid) {
                console.log("UID received, logging in...", uid);
                await testLogin(uid);
                stopListener();
              }
            }
          });
        },
        (error) => {
          console.error("Firestore listener error:", error);
        }
      );
  };

  const stopListener = () => {
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
      unsubscribeRef.current = null;
      console.log("Firestore listener stopped.");
    }
  };

  const createLogin = async () => {
    try {
      const scanRef = db.collection("loginByScan").doc();
      await scanRef.set({ uid: "", docId:scanRef.id });
      console.log("Login document created:", scanRef.id);
      startListener(scanRef.id);
      setDocId(scanRef.id)
    } catch (error) {
      console.error("Error creating login:", error);
    }
  };

  const testLogin = async (uid) => {
    try {
      const { status, data } = await shopchamAPI.post("/users/scan/", { uid });

      if (status === 200) {
        const { frbUserCustomToken } = data;
        dispatch(signin_customToken(frbUserCustomToken));
        console.log("User authenticated successfully.");
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  return (
    <div>
      <Button onClick={createLogin}>Create Login</Button>
        {docId
            ?<QRCodeSVG value={docId} />
            :null
        }
    </div>
  );
}

export default LoginByScan;
